import { render, staticRenderFns } from "./ClientViewWorkshop.vue?vue&type=template&id=26ba0c62&"
import script from "./ClientViewWorkshop.vue?vue&type=script&lang=js&"
export * from "./ClientViewWorkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports